import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { Box, Typography, Container } from '@mui/material';

const ContractDeclined: React.FC = () => {
  const location = useLocation();
  const message = location.state?.message;

  if (!message) {
    return <Navigate to="/" replace />;
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" component="h1" gutterBottom>
          Contract Response Received
        </Typography>
        <Typography variant="body1">
          {message}
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          You may now close this window.
        </Typography>
      </Box>
    </Container>
  );
};

export default ContractDeclined;
